import { useEffect } from "react";

const Message = ({ apiMessage, setApiMessage }) => {
  useEffect(() => {
    if (apiMessage?.message) {
      const timeoutId = setTimeout(() => {
        setApiMessage(null); // clear after 3s
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [apiMessage, setApiMessage]);

  if (!apiMessage) return null;

  return (
    <div
      className={`w-full px-4 py-3 mb-4 rounded-md text-base font-medium ${
        apiMessage.type === "success"
          ? "bg-green-100 text-green-800 border border-green-300"
          : "bg-red-100 text-red-800 border border-red-300"
      }`}
    >
      {apiMessage.message}
    </div>
  );
};

export default Message;
